<template>
  <div class="text-right mr-3">
    <v-menu v-model="menuEdicao" :close-on-content-click="true" max-width="350px" offset-y v-if="showLotesAlocados">
      <template v-slot:activator="{ on, attrs }">
        <v-badge 
          overlap
          class="mr-3" 
          style="font-weight: bold"
          :color="lotesList.length ?'accent' : 'transparent'"
          :content="lotesList.length"
        >
        <v-btn
          icon
          class="elevation-0 font-weight-black text-center"
          v-bind="attrs"
          v-on="on"
          :disabled="lotesList.length == 0 ?true :false"
        >
        <v-icon class="pt-1" color="black">far fa-edit</v-icon>
        </v-btn>
        </v-badge>
      </template>

      <v-card>
        <v-list subheader>
          <v-subheader>Lotes em edição</v-subheader>
          <v-list-item v-for="item in lotesList" :key="item.id">
            <v-list-item-content>
              <v-list-item-title class="mb-0 pb-0">N<sup>o</sup> {{item.arq_numero_lote}}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <small v-bind="attrs" v-on="on"  class="pl-3">{{item.arq_nome}}</small>
                  </template>
                  {{item.arq_nome}}
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>{{item.oper_nome}} - {{item.prest_nome}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <v-btn v-if="!item.desfazendo_edicoes" :disabled="$route.params.id == item.id" icon @click="$router.push('/faturamento/cronogramas/dadosdocronograma/detalhesdolote/'+item.id)">
                <v-icon color="primary" small>fas fa-external-link-alt</v-icon>
              </v-btn>
              <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="pa-0">
                      <v-progress-circular
                        :size="12"
                        :width="1"
                        color="primary"
                        indeterminate
                        class="pt-7"
                      ></v-progress-circular>
                    </span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                    Desfazendo edições
                  </span>
              </v-tooltip>

            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-badge 
          overlap
          class="mr-6 ml-0" 
          style="font-weight: bold"
          :color="newMessagesCount? 'accent' : 'transparent'"
          :content="newMessagesCount"
        ><v-btn 
          icon
          v-bind="attrs"
          v-on="on" 
          @click="$router.push('/notificacoes')">
          <v-icon class="pt-1" color="black">far fa-bell</v-icon>
        </v-btn>
        </v-badge>
      </template>
      Notificações
    </v-tooltip>

    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          small
          color="primary"
          class="elevation-0 font-weight-black text-center"
          v-bind="attrs"
          v-on="on"
        >
          <span class="black--text headline">{{getInicials(userData.Nome)}}</span>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar color="primary">
              <span class="black--text headline">{{getInicials(userData.Nome)}}</span>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{userData.Nome}}</v-list-item-title>
              <v-list-item-subtitle>{{userData.Email}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn
                icon
                @click="menu = false"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list class="font-weight-black">
          <v-list-item  @click="changePassword">
            <v-list-item-content>
              <v-list-item-title>
                Mudar Senha 
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item  @click="logout">
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>
<script>

import { mapState, mapActions } from "vuex"

export default {
  data() {
    return {
      menu: false,
      menuEdicao: false,
      showLotesAlocados: false
    }
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      newMessagesCount: state => state.notifications.newMessagesCount,
      permissaoBase: (state) => state.permissions.permissaoBaseCadastro,
      lotesList: (state) => state.faturamento.lotesList,
    }),
  },
  props:{
    userData: Object
  },
  mounted() {
    if (this.userData.Permissao && this.userData.Permissao.faturamento) {
      if (this.userData.PermissaoAcoes.faturamento.includes('updatecronograma'))
        this.getLotesAlocados({grupo_economico: this.grupoEconomico})
        this.showLotesAlocados = true
    }
  },
  methods:{
    ...mapActions('faturamento', [
      'getLotesAlocados'
    ]),
    getInicials(nome){
      let names =  nome.split(' ')
      if(names.length>1) {
        return names[0].substr(0,1) + names[1].substr(0,1)
      } else {
        return names[0].substr(0,2)
      }
    },
    logout(){
      return this.$store
        .dispatch("authenticator/doLogout")
        .then(() => sessionStorage.clear())
    },
    changePassword(){
      this.$router.push("/mudarsenha").catch(()=>{})
    }
  }
}
</script>